import { useCallback, useEffect, useState } from "react";
import SolicitacaoProfissional from "../../../models/SolicitacaoProfissional";
import SolicitacaoApoiador from "../../../models/SolicitacaoApoiador";
import SolicitacaoPatrocinador from "../../../models/SolicitacaoPatrocinador";
import { respostaOk } from "../../../utils/resposta";

// Nome do evento que a página de pedidos dispara depois de aprovar/recusar, para
// o selo do menu acompanhar sem recarregar a página.
export const EVENTO_PEDIDOS_ALTERADOS = "geoplantio:pedidos-alterados";

export function avisarPedidosAlterados() {
  window.dispatchEvent(new Event(EVENTO_PEDIDOS_ALTERADOS));
}

// Pedidos aguardando resposta, POR TIPO: perfil Profissional
// (GET /solicitacoes-profissional/contagem), apoiador (/solicitacoes-apoiador/contagem)
// e patrocinador (/solicitacoes-patrocinador/contagem), só administrador. `habilitado` evita consultar rotas admin para quem não é
// administrador. Cada contagem falha sozinha: se uma rota não responder, ela vale 0
// e as outras continuam valendo.
export function usePendentesPorTipo(habilitado) {
  const [pendentes, setPendentes] = useState({ profissional: 0, apoiador: 0, patrocinador: 0 });

  const atualizar = useCallback(async () => {
    const [prof, apoio, patro] = await Promise.all([
      SolicitacaoProfissional.contagem(), SolicitacaoApoiador.contagem(), SolicitacaoPatrocinador.contagem(),
    ]);
    setPendentes({
      profissional: respostaOk(prof) ? prof.data.pendentes || 0 : 0,
      apoiador: respostaOk(apoio) ? apoio.data.pendentes || 0 : 0,
      patrocinador: respostaOk(patro) ? patro.data.pendentes || 0 : 0,
    });
  }, []);

  useEffect(() => {
    if (!habilitado) return undefined;
    atualizar();
    window.addEventListener(EVENTO_PEDIDOS_ALTERADOS, atualizar);
    return () => window.removeEventListener(EVENTO_PEDIDOS_ALTERADOS, atualizar);
  }, [habilitado, atualizar]);

  return { ...pendentes, total: pendentes.profissional + pendentes.apoiador + pendentes.patrocinador };
}

// Total de pedidos aguardando (os três tipos somados): é o número do selo do menu.
export default function usePendentes(habilitado) {
  return usePendentesPorTipo(habilitado).total;
}
